import React from 'react'

import { B4, B5, Icon, Stack, XStack, colors } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'

import StarSingleBlue from '../../../assets/svg/starSingleBlue.svg'

type Props = {
  partnerName?: string
  customerName?: string
}
const OtherBrandsStrip = ({ partnerName, customerName }: Props) => {
  return (
    <LinearGradient
      colors={['#B9D4FF', '#E5EFFF']}
      start={[0, 0]}
      end={[1, 0.0]}
      locations={[0.0, 0.93]}
      className="px-3"
    >
      <XStack className="items-center justify-between">
        <XStack className="flex-1 items-center justify-center">
          <Stack className="mr-2">
            <StarSingleBlue />
          </Stack>

          {i18n.locale == 'en' ? (
            <B5 className="text-primary-200 flex-1 py-3">
              <B4 className="text-primary-200 py-3">{customerName || ''}</B4>
              {i18n.t('magnetCrossSelling.magnetOnListing.isEligibleFor')}
              <B4 className="text-primary-200 py-3">{partnerName || ''}</B4>
            </B5>
          ) : (
            <B5 className="text-primary-200 flex-1 py-3">
              <B4 className="text-primary-200 py-3">
                {customerName + ' ' || ''}
              </B4>
              <B4 className="text-primary-200 py-3">{partnerName || ''}</B4>
              {i18n.t('magnetCrossSelling.magnetOnListing.isEligibleFor')}
            </B5>
          )}
        </XStack>
        <Stack>
          <Icon type="ArrowRight" color={colors.primary[200]} size={24} />
        </Stack>
      </XStack>
    </LinearGradient>
  )
}

export { OtherBrandsStrip }
